import { Injectable } from '@angular/core';
import rest from '@feathersjs/rest-client';
import feathers from '@feathersjs/feathers';
//import array from './parse/json/recipes_he.json'


@Injectable({
  providedIn: 'root'
})
export class TestService {
  private feathersRest;
  constructor() { }

  async testFeathers() {
    return;
    /*
    const client = feathers();
    this.feathersRest = rest("http://localhost:3310");
    client.configure(this.feathersRest.fetch(window.fetch));


    array.forEach(async (element) => {

      const res = await client.service('recipes').find(
        {
          query:
          {
            title: element.title,
            lang: element.lang,
          }
        })
      let fromServer = res.data[0];

      delete fromServer.image

      fromServer.preparation = element.preparation
      fromServer.ingredients = element.ingredients

      if (element.preparation.length > 0 || element.ingredients.length > 0) {
        await client.service('recipes').patch(fromServer._id, {
          _id: fromServer._id,
          preparation: element.preparation,
          ingredients: element.ingredients,
        })
      }

    });
    */


  }
  testFeathers2() {
    const client = feathers();
    this.feathersRest = rest("http://localhost:3310");
    client.configure(this.feathersRest.fetch(window.fetch));
    client.service('days').get('629345aea5fddb20bd5c47b0')
  }
}
